import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LoginButton: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <button
      onClick={() => loginWithRedirect()}
      className="btn-primary px-8 py-3 text-lg"
    >
      🔐 Log In
    </button>
  );
};

export default LoginButton;
